import { createRouter, createWebHistory } from "vue-router";
import HUCpsTool from "@/views/HUCpsTool.vue";
import DomainControl from "@/views/DomainControl/DomainControl.vue";
import PreviewInfo from "@/views/DomainControl/PreviewInfo.vue";
import CarTestLayout from "@/views/carTest/CarTestLayout.vue";
import CarPluginTest from "@/views/carTest/ss3/CarPluginTest.vue";
import VehiclePropertyTest from "@/views/carTest/ss3/VehiclePropertyTest.vue";
import CarPropertyClientTest from "@/views/carTest/ss4/CarPropertyClientTest.vue";
import CarDiagTest from "@/views/carTest/ss4/CarDiagTest.vue";
import VehiclePropertyMapperTest from "@/views/carTest/ss4/VehiclePropertyMapperTest.vue";
import SignalExplorer from "@/views/carTest/ss4/SignalExplorer.vue";
import VBSTest from "@/views/carTest/VBSTest.vue";
import ErrorNotFound from "@/views/ErrorNotFound.vue";

const domainControl = [
  {
    path: "/domain-control",
    name: "DomainControl",
    component: DomainControl,
    children: [
      {
        path: "",
        name: "DomainControlDefault",
        redirect: {
          name: "DomainControl_PreviewInfo",
        },
      },
      {
        path: "preview-info",
        name: "DomainControl_PreviewInfo",
        component: PreviewInfo,
      },
    ],
  },
];

const routes = [
  {
    path: "/",
    redirect: "/domain-control",
  },
  ...domainControl,
  {
    path: "/hu-cps-tool",
    name: "HUCpsTool",
    component: HUCpsTool,
  },
  {
    path: "/car-tests",
    name: "CarTestLayout",
    component: CarTestLayout,
    redirect: { name: "SignalExplorer" },
    children: [
      {
        path: "ss3/car-plugin-test",
        name: "CarPluginTest",
        component: CarPluginTest,
      },
      {
        path: "ss3/vehicle-property-test",
        name: "VehiclePropertyTest",
        component: VehiclePropertyTest,
      },
      {
        path: "ss4/car-property-client-test",
        name: "CarPropertyClientTest",
        component: CarPropertyClientTest,
      },
      {
        path: "ss4/car-diag-test",
        name: "CarDiagTest",
        component: CarDiagTest,
      },
      {
        path: "ss4/vehicle-property-mapper-test",
        name: "VehiclePropertyMapperTest",
        component: VehiclePropertyMapperTest,
      },
      {
        path: "ss4/signal-explorer",
        name: "SignalExplorer",
        component: SignalExplorer,
      },
      {
        path: "vbs/vbs-test",
        name: "VBSTest",
        component: VBSTest,
      },
    ],
  },
  {
    path: "/:catchAll(.*)*",
    component: ErrorNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
